import { Feed, NoMoreFeedItemsCallbackProp } from "@components/feed";
import { PageSection } from "@components/layout/PageSection";
import React, { useCallback } from "react";

import {
  FeedItemResponse,
  UserResponse,
} from "@every.org/common/src/codecs/entities";
import { FeedPage } from "@every.org/common/src/entity/types";

import { fetchUserFundsFeed } from "src/context/DonationsContext/actions";

interface FundsTabProps extends NoMoreFeedItemsCallbackProp {
  user: UserResponse;
  listFeed?: FeedItemResponse[];
  listHasMore?: boolean;
}
export const FundsTab = ({
  user,
  onNoMoreItems,
  listFeed,
  listHasMore,
}: FundsTabProps) => {
  return (
    <FundsFeed
      listFeed={listFeed}
      listHasMore={listHasMore}
      userId={user.id}
      onNoMoreItems={onNoMoreItems}
    />
  );
};

interface FundsFeedProps extends NoMoreFeedItemsCallbackProp {
  userId: UserResponse["id"];
  listFeed?: FeedItemResponse[];
  listHasMore?: boolean;
}

/**
 * Feed of donations from a given user.
 */
const FundsFeed = ({
  userId,
  onNoMoreItems,
  listFeed,
  listHasMore,
}: FundsFeedProps) => {
  return (
    <PageSection>
      <Feed
        initialItems={listFeed}
        initialHasMore={listHasMore}
        page={FeedPage.USER_PROFILE}
        loadMoreItems={useCallback(
          (params) => fetchUserFundsFeed({ userId, ...params }),
          [userId]
        )}
        onNoMoreItems={onNoMoreItems}
      />
    </PageSection>
  );
};
